export const ORDER_DATA = "ORDER_DATA";
export const ORDER_DETAIL = "ORDER_DETAIL";
export const ALL_MENU = "ALL_MENU"
export const LANDING_BANNERS = "LANDING_BANNERS"
export const HOME_GROUPS = "HOME_GROUPS"
export const TOP_DEALS = "TOP_DEALS"
export const BEST_SELLERS = "BEST_SELLERS"
export const ITEM_DETAIL = "ITEM_DETAIL"
export const COMBO_DETAIL = "COMBO_DETAIL"
export const ORDER_LIST = "ORDER_LIST";
export const CROSS_SELL = "CROSS_SELL"
export const LAST_FIVE_ORDERS = "LAST_FIVE_ORDERS"
export const REMOVE_LAST_FIVE_ORDERS = "REMOVE_LAST_FIVE_ORDERS"
export const REMOVE_ORDER_DATA = "REMOVE_ORDER_DATA"
export const WEB_APP_THEME = "WEB_APP_THEME"